package de.ohhhmhhh.backend.models.model.revocation

import kotlinx.serialization.Serializable

@Serializable
enum class RevocationStateEntity {
    OPEN, APPROVED, REJECTED
}